/**
 *
 * CardMember
 *
 */

import React from "react"
// import PropTypes from 'prop-types';
// import styled from 'styled-components';
import { Avatar } from "antd"
import checkImg from "../../images/check-measure.svg"
import xImg from "../../images/xred.svg"
import "./index.less"
/* eslint-disable react/prefer-stateless-function */
class CardMember extends React.Component {
  render() {
    const { data, hideStatus } = this.props
    return (
      <div key={data.id_employee} className="CardMemberComponent">
        <div>
          <Avatar size={50} src={data.picture_profile} />
        </div>
        <div>
          <span className="CardMemberComponent-name">
            <div>
              {data.full_name}
              {!hideStatus && <img src={data.survey_done ? checkImg : xImg} />}
            </div>
          </span>
          <span className="CardMemberComponent-position">
            {data.position_name}
          </span>
        </div>
      </div>
    )
  }
}

CardMember.propTypes = {}

export default CardMember
